<ng-template #messagesList let-msgList="messages">
	@if (msgList?.length > 0) {
		<cdk-virtual-scroll-viewport
			itemSize="autosize"
			[style.height.px]="viewportHeight()"
			class="messages-list"
		>
			<div class="Table" #messagesContainer>
				<div
					class="Table-row"
					*cdkVirtualFor="let message of msgList"
					[ngClass]="{ newMessage: isMessageUnreadByCustomer(message) }"
				>
					<div class="Table-row-item xxs icon flex-wrap">
						@if (isMessageUnreadByCustomer(message)) {
							<i>{{ "NEW" | translate }}</i
							>&nbsp;
						}
						<fa-icon
							[icon]="MessageTypeIcons[message.type].icon"
							[ngClass]="{
								warning: message.type === MessageTypes.Warning,
								problem: message.type === MessageTypes.Problem,
							}"
						></fa-icon>
						@if (message.scope === MessageScopes.PublicWithEmailNotification) {
							<fa-icon [icon]="faEnvelope" style="margin-left: 5px"></fa-icon>
						}
					</div>
					<div class="Table-row-item xs">
						{{ message.created | date: "dd.MM.yyyy" : "EUROPE/BERLIN" : config.locale }}<br />
						{{ message.created | date: "HH:mm" : "EUROPE/BERLIN" : config.locale }}
					</div>
					<div class="Table-row-item xxs">{{ getSendersTypeLabel(message.sendersType) }}<br /></div>
					<div class="Table-row-item xl text" [innerHTML]="message.message"></div>
				</div>
			</div>
		</cdk-virtual-scroll-viewport>
	} @else {
		<div class="no-messages" [ngStyle]="{ '--viewportHeight': viewportHeight() + 'px' }">
			<p>{{ "no notifications" | translate }}</p>
		</div>
	}
</ng-template>

@if (associatedTreatmentEntries().length > 0) {
	<mat-tab-group [(selectedIndex)]="selectedTabIndex">
		<mat-tab label="{{ 'CurrentTreatmentHeader' | translate }}">
			<ng-container *ngTemplateOutlet="messagesList; context: { messages: messages() }" />
		</mat-tab>
		@for (entry of associatedTreatmentEntries(); track entry.treatmentId) {
			<mat-tab
				label="{{ 'AssociatedTreatmentHeader' | translate }} {{
					associatedTreatmentEntries().length > 1 ? '(' + ($index + 1) + ')' : ''
				}}"
			>
				<ng-container *ngTemplateOutlet="messagesList; context: { messages: entry.messages }" />
			</mat-tab>
		}
	</mat-tab-group>
} @else {
	<ng-container *ngTemplateOutlet="messagesList; context: { messages: messages() }" />
}
